<template>
  <div>
    <Head title="Brands" />
    <h1 class="mb-8 text-3xl font-bold">Brands</h1>
    <div class="flex items-center justify-between mb-6">
      <search-input v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
      </search-input>
      <Link class="btn-indigo" href="/brands/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Brand</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Name</th>
          <th class="pb-4 pt-6 px-6">Domain</th>
          <th class="pb-4 pt-6 px-6" colspan="2">CreatedAt</th>
        </tr>
        <tr v-for="brand in brands" :key="brand.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/brands/${brand.id}/edit`">
              {{ brand.name }}
              <icon v-if="brand.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/brands/${brand.id}/edit`" tabindex="-1">
              {{ brand.domain_frontend }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/brands/${brand.id}/edit`" tabindex="-1">
              {{ brand.created_at }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/brands/${brand.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="brands.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No brands found.</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchInput from '@/Shared/SearchInput'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    brands: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/brands', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
